import React,{useEffect} from 'react';
import MenuItems from '../Components/MenuItems';
import Tittle from '../Components/Tittle';
import portfolios from '../Components/allportfolios';
import { useState } from 'react';
import Aos from "aos"
import "aos/dist/aos.css"
import Fade from 'react-reveal/Fade';

const allCategories = ['All', ...new Set(portfolios.map(item => item.category))];

function PortfoliosPage() 
{
    const [menuItems, setMenuItems] = useState(portfolios);
    useEffect(() =>{
        Aos.init({durations:2000});
    },[]);
    return (
      
        <div  data-aos="fade-up" className="PortfolioPage" >
            <div className="title">
                <Tittle title={'PROJECTS'} span={'project'} />
            </div>
            <Fade left>
            <div  data-aos="fade-up" className="portfolios-data">
                <MenuItems menuItem={menuItems} />
            </div>
            </Fade>
        </div>
       
    )
}
export default PortfoliosPage;
